import * as api from "../api";
import {
  CREATESTATICINFO,
  GETSTATICINFO,
  UPDATESTATICINFO,
} from "../constants/actionTypes";
import { message } from "antd";

export const createStoreInfo =
  (formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.createStoreInfo(formData);
      dispatch({ type: CREATESTATICINFO, data });
      if (data) {
        setLoadingButton(false);
        history("/website");
        message.success("Information added successfully");
      }
    } catch (error) {
      if (error) {
        console.log(error);
        setLoadingButton(false);
        message.error(error?.response?.data);
      }
    }
  };

export const updateStoreInfo =
  (id, formData, history, setLoadingButton) => async (dispatch) => {
    try {
      const { data } = await api.updateStoreInfo(id, formData);
      dispatch({ type: UPDATESTATICINFO, payload: data });
      if (data?._id) {
        setLoadingButton(false);
        history("/website");
        message.success("Information updated successfully");
      }
    } catch (error) {
      if (error) {
        setLoadingButton(false);
        console.log(error);
        message.error(error?.response?.data);
      }
    }
  };
